import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';
import reporte from './Vivero_reporte_procesador.js';
import { dateFormatConDiaShort } from '../../../../utils/DateFunctions.jsx';
import ReporteSiembra from './components/ReporteSiembra.jsx';
import ReportePorFecha from './components/ReportePorFecha.jsx';
import MultiBarChart from '../../../charts/MultiBarChart.jsx';
import ReporteBloqueIndividual from './components/ReporteBloqueIndividual.jsx';
import vr from '../../../../utils/Verifiers.jsx';
import VainillaDialogV2 from '../../../../utils/VainillaDialogv2.jsx';

const Actividades_vivero = () => {
    const [dialog, setdialog] = useState();
    const [info_rep, setinfo_rep] = useState({
        dia: '',
        semana: '',
        solo_dia: "",
        general: [],
        reporte_por_fecha: [],
        reporte_siembra: [],
        avance_bloques: [],
        avance_bloques_charts: [],
        avance_bloques_individual: [],
        genral_charts_semana: [],
        rango: ['', '']
    });

    const [data_send, setdata_send] = useState({ fecha: '', semana: '', dia: '', flor: '-1', variedad: '-1', color: '-1' });

    const [filtros, setfiltros] = useState({
        flores: [{ nombre: 'TODAS LAS FLORES', id: -1 }],
        variedades: [{ nombre: 'TODAS LAS VARIEDADES', id: -1 }],
        colores: [{ nombre: 'TODOS LOS COLORES', id: -1, }],
        semanas: [],
        dias: [{ nombre: 'Lunes', id: 1 }, { nombre: 'Martes', id: 2 }, { nombre: 'Miércoles', id: 3 }, { nombre: 'Jueves', id: 4 }, { nombre: 'Viernes', id: 5 }, { nombre: 'Sábado', id: 6 }]
    });

    useEffect(() => {
        getReport();
    }, []);

    const getReport = async (d) => {
        if (!d) d = { ...data_send };
        let resp = await Post('reportes/vivero_dia', d);
        if (resp.estatus === false) {
            vr.activeDialog(setdialog, resp.msj, 'PROBLEMA AL OBTENER LOS DATOS');
            return;
        }
        let rep = new reporte(resp);
        setinfo_rep({
            solo_dia: (resp?.data?.dia ?? 'Día').toUpperCase(),
            dia: rep.dia ?? '',
            semana: resp.data.semana,
            rango: resp.data.rango,
            chart_keys: rep.genral_charts_keys,
            reporte_siembra: rep.reporte_siembra,
            reporte_por_fecha: rep.reporte_por_fecha,
            avance_bloques: rep.avance_bloques,
            avance_bloques_charts: rep.avance_bloques_charts,
            avance_bloques_individual: rep.avance_bloques_individual,
        });
        setdata_send(d);

        if (filtros.semanas.length === 0) {
            Post('reportes/semanas_rangos', {}).then((resp) => {
                let fill = { flores: rep.flores, variedades: rep.variedades, colores: rep.colores, semanas: filtros.semanas, dias: filtros.dias }
                fill.semanas = resp.data ?? [];
                setfiltros(fill);
            });
        }
        else setfiltros({ flores: rep.flores, variedades: rep.variedades, colores: rep.colores, semanas: filtros.semanas, dias: filtros.dias });

        d.dia = resp.data.dia_num;
        d.semana = resp.data.semana;
        setdata_send(d);

    }

    const changeFiltro = (event) => {
        let d = { ...data_send };
        d[event.target.name] = event.target.value;
        if (event.target.name == 'fecha') {
            d.semana = '';
            d.dia = '';
        } else if (event.target.name == 'semana') {
            d.fecha = '';
        }
        getReport(d);

    }

    return (
        <div className='w-100 m-0 round-l shadow-multi relative dosis' style={{ height: '100%', width: '100%', overflow: 'auto', border: 'solid 1px #D1D1D1' }}>
            <div className='col-lg-12 p-1 dosis shadow-multi-sm blur-xl bg-white4 round-top contenedor absolute top' style={{
                position: 'sticky',
                top: 0,
                left: 0,
                zIndex: '5'
            }}>
                <div className='row justify-content-evenly m-0 p-0 w-100'>
                    <div className='col-auto h2 '>
                        Reportes <span className='h4 text-orange4 ms-2'>Vivero</span>
                    </div>

                    <div className='form-group col-auto m-1 p-0' style={{ lineHeight: '1' }}>
                        <div className='w-100 text-xs text-bold'>Semana siembra</div>
                        <select className='form-control form-control-sm shadow-sm border text-center m-0 w-100' name='semana' value={data_send.semana} onChange={changeFiltro}>
                            <option value={""} >{'Semana'}</option>
                            {
                                filtros.semanas.map((sm, i) => {
                                    return (
                                        <option value={sm.semana} key={sm.semana + i}>{sm.semana}</option>
                                    )
                                })
                            }

                        </select>
                    </div>

                    <div className='form-group col-auto m-1 p-0' style={{ lineHeight: '1' }}>
                        <div className='w-100 text-xs text-bold'>Día de la semana</div>
                        <select className='form-control form-control-sm shadow-sm border m-0 w-100 text-center' name='dia' value={data_send.dia} onChange={changeFiltro}>
                            {
                                filtros.dias.map((dia, i) => {
                                    return (
                                        <option value={dia.id} key={dia.nombre + i}>{dia.nombre}</option>
                                    )
                                })
                            }

                        </select>
                    </div>

                    <div className='form-group col-auto m-1 p-0' style={{ lineHeight: '1' }}>
                        <div className='w-100 text-xs text-bold'>Filtrado por flor</div>
                        <select className='form-control form-control-sm shadow-sm border m-0 w-100 text-center' name='flor' onChange={changeFiltro}>
                            {
                                filtros.flores.map((flor, i) => {
                                    return (
                                        <option value={flor.id} key={flor.nombre + i}>{flor.nombre}</option>
                                    )
                                })
                            }

                        </select>
                    </div>

                    <div className='form-group col-auto m-1 p-0' style={{ lineHeight: '1' }}>
                        <div className='w-100 text-xs text-bold'>Filtrado por variedad</div>
                        <select className='form-control form-control-sm shadow-sm border m-0 w-100 text-center' name='variedad' onChange={changeFiltro}>
                            {
                                filtros.variedades.map((vari, i) => {
                                    return (
                                        <option value={vari.id} key={vari.nombre + i}>{vari.nombre}</option>
                                    )
                                })
                            }

                        </select>
                    </div>

                    <div className='form-group col-auto m-1 p-0' style={{ lineHeight: '1' }}>
                        <div className='w-100 text-xs text-bold'>Filtrado por color</div>
                        <select className='form-control form-control-sm shadow-sm border m-0 w-100 text-center' name='color' onChange={changeFiltro}>
                            {
                                filtros.colores.map((color, i) => {
                                    return (
                                        <option value={color.id} key={color.nombre + i}>{color.nombre}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                </div>
            </div>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='m-0 p-2 bw-1500'>
                    <div className='row justify-content-evenly m-0 p-0'>
                        <div className='col-lg-12 p-1 m-1 text-orange4 h4 dosis text-center'>
                            {info_rep.dia} -
                            <span className='text-m ms-1 me-2'>Semana {info_rep.semana}</span>

                            <span className='text-s'> ({dateFormatConDiaShort(info_rep.rango[0])} - {dateFormatConDiaShort(info_rep.rango[1])})</span>
                        </div>
                        <ReporteSiembra reporte={info_rep.reporte_siembra} dia={info_rep.solo_dia} semana={info_rep.semana} data_send={data_send} />
                        <ReportePorFecha reporte={info_rep.reporte_por_fecha} dia={info_rep.solo_dia} semana={info_rep.semana} data_send={data_send} />
                        <div className='row justify-content-start w-100 m-0 p-0'>
                            <div className='w-80 m-0 p-0 mt-4 h3 border-bottom'>Reporte de avances concentrado</div>
                        </div>

                        {
                            info_rep.avance_bloques_charts.map((chrt, i) => <React.Fragment key={i}>
                                <div className='w-100 m-0 p-0' />
                                <div className='bw-1500 m-0 p-0'>
                                    <MultiBarChart data={chrt.data} config={chrt.config} title={chrt.title} height={150} maxWid={true} />
                                </div>

                            </React.Fragment>)
                        }

                        {
                            info_rep.avance_bloques_individual.length > 0 && <div className='bw-1500'>
                                <div className='w-80 m-0 p-0 mb-3 mt-4 h3 border-bottom'>Reporte de avances por bloque</div>
                                {
                                    info_rep.avance_bloques_individual.map((bloq, i) => <React.Fragment key={bloq.bloque_nombre + i}>
                                        <ReporteBloqueIndividual reporte={bloq} />
                                    </React.Fragment>)
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
            <VainillaDialogV2 data={dialog} />
        </div>
    )
}

export default Actividades_vivero;